export default "__VITE_ASSET__DKAF2iNT__"